import React from 'react';

const Display = ({ question }) => {
  const supportLink = question.extension.find((extension) => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink'
  });

  const supportImage = question.extension.find((extension) => {
    return extension.url === 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage'
  });

  return <>
    <h6 className="card-title" style={{ whiteSpace: 'pre-line' }}>{question.linkId}. {question.text || 'Enter your display instructions.'}</h6>

    {supportImage &&
      <div><img width="200px" src={supportImage.valueUri} className="img-thumbnail mb-3" alt="Diagram" /></div>
    }

    {supportLink &&
      <div><a href={supportLink.valueUri} className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">Click link to review</a></div>
    }
  </>;
}

export default Display;